module.exports = __webpack_public_path__ + "img/suplier-icon.33328a86.svg";